// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___jQQ8","name":"styles_name__31B2P","phone":"styles_phone__36Nr0"};